import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { SelectItem } from 'primeng/primeng';
import { Message } from 'primeng/primeng';
import { RoleService } from '../../roles/role.service';
import { StoreService } from '../../stores/store.service';
import { ContactService } from '../../contacts/contact.service';
import { ActivatedRoute} from '@angular/router';

import { UserService } from '../user.service';
import { User } from '../user'; 
 

@Component({
  selector: 'app-user-crud',
  templateUrl: './user-crud.component.html',
  styleUrls: ['./user-crud.component.css'],
  providers: [
              UserService,
              RoleService,
              StoreService,
              ContactService
             ]
})
export class UserCrudComponent implements OnInit {

  _defaultLabel: string="Выберите хранилищ...";

  _mediumLabel: string="Средний";

  _promptLabel: string="Введите пароль!";

  _strongLabel: string="Сложный";

  _weakLabel: string="Легкий";

  button_caption: string ="Сохранить"

  button_icon:string ="fa fa-save";

  id: any =null;

  loading: boolean = false;

  msgs: Message[] = [];

  multiLabel: string; 

  selectedContact: string;

  selectedRoles: string[]=[];

  selectedStores: string[];

 

  user: User;

  constructor(
              private activatedRoute: ActivatedRoute,
              private contactService: ContactService,
              private location: Location,
              private roleService: RoleService,
              private router: Router,
              private storeService: StoreService,
              private userService: UserService
              ) { 
   
    activatedRoute.params.subscribe(params=>{this.id=params['id']});
  
    if(this.id){

        this.loading=true;   

        this.userService.getUserById(this.id).subscribe(response=>{

            this.contactService.getContactList().subscribe(response=>{this.user.contacts=response['data'].map(function(value: any){
                return {label:value.full_name, value: value.id};
            }); })

            this.selectedContact=response['data'].contact['id'];

      

            this.selectedRoles=response['data'].roles.map(function(value: any){
                return value.id;
              });

            this.storeService.getStore().subscribe(response=>{this.user.stores=response['data'].map(function(value: any){
               return {label:value.name, value: value.id};
             });
          })
            this.roleService.getRole(1).subscribe(response=>{this.user.roles=response['data'].map(function(value: any){
                return {label:value.display_name, value: value.id};
            });
            this.loading=false;
            })

           
             this.selectedStores=response['data'].stores.map(function(value: any){
              return value.id;
             });
            
          this.user=response['data']


        });  


     this.button_caption="Редактировать";
     this.button_icon="fa fa-edit"; 

    }else{  
            this.contactService.getContactList().subscribe(response=>{this.user.contacts=response['data'].map(function(value: any){
                return {label:value.full_name, value: value.id};
            }); })

            this.roleService.getRole(1).subscribe(response=>{this.user['roles']=response['data'].map(function(value: any){
                return {label:value.display_name, value: value.id};
            }); })

            this.storeService.getStore().subscribe(response=>{this.user.stores=response['data'].map(function(value: any){
                return {label:value.name, value: value.id};
            }); })


        }
  }

  ngOnInit() {

    this.user={
      id: "",
      username: "",
      email: "",
      contacts: [],
      stores: [],
      roles: [],
      available: true
    };
  }

   backClicked() {
          this.location.back();
   }
  
   crud(form: NgForm){
            
       this.loading=true; 
       if(this.id){
           form.value['username'] = this.user.username; // when element username enabled dont put in form.value
           this.userService.putData(form['value'],this.id)
                   .subscribe((data) => {this.loading=false;this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно изменено!"});}
                     , (error)=>{
                           this.loading=false; 
                     });
       }else{
       this.userService.postData(form['value'])
                   .subscribe((data) => {this.loading=false;this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно добавлено!"});}
                     , (error)=>{  
                              this.loading=false; 
                        });
       }
   }
  
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/users/user-crud/user-crud.component.ts